import { asyncRoutes, constantRoutes } from '@/router'
// import { getRoutes } from '@/api/login'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
	if (route.name !== undefined) {
		if (roles.indexOf(route.name) > -1) {
			return true
		} else {
			return false
		}
	} else {
		return false
	}
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
	//  'applicationIndex','qualifications', 'annualReport',

	// roles.push('weAppFilings')
	roles.push(
		'homeEditor',
		'intelligentLedger',
		'costCenter',
		'FullCalendar',
		'ShiTable'
	)
	// roles.push(
	// 	'followUpRecords', //跟进记录
	// 	'reportForms', //绩效报表
	// 	'assessors', //考评人员
	// 	'performanceWorkbench', //考核工作台
	// 	'performanceStandards', //考核标准
	// 	'assessmentDetails', //考核详情
	// 	'contractTemplate', //合同模版
	// 	'jointVentureContract' //企业合同
	// )
	const res = []
	// if (localStorage.getItem('enterprise') == 'true') { // 企业信息
	//   for (let d = 0; d < roles.length; d++) {
	//     if (roles[d] == 'enterpriseCertification') {
	//       roles.splice(d, 1)
	//     }
	//   }
	// } else if (localStorage.getItem('enterprise') == 'false') { // 企业认证
	//   for (let d = 0; d < roles.length; d++) {
	//     if (roles[d] == 'enterpriseInformation') {
	//       roles.splice(d, 1)
	//     }
	//   }
	// }

	routes.forEach((route) => {
		const tmp = { ...route }
		// 此层判断是为了解决在没有 noRedirect 并且 roles 没有权限的情况下报内存溢出的错误
		if (
			tmp.redirect === 'noRedirect' ||
			roles.indexOf(tmp.name) != -1 ||
			tmp.redirect === '/404'
		) {
			if (tmp.children) {
				const children = []
				for (var i = 0; i < tmp.children.length; i++) {
					if (hasPermission(roles, tmp.children[i])) {
						children.push(tmp.children[i])
					}
				}
				tmp.children = children
			}
			if (
				(tmp.children && tmp.children.length > 0) ||
				tmp.redirect === '/404'
			) {
				res.push(tmp)
			}
		}

		// if (tmp.children) {
		//   const children = []
		//   for ( var i = 0 ; i < tmp.children.length; i++ ){
		//     if (hasPermission(roles,tmp.children[i])){
		//         children.push(tmp.children[i])
		//       }
		//   }
		//   tmp.children = children
		// }
		// if ((tmp.children && tmp.children.length > 0) || tmp.redirect === '/404') {
		//     res.push(tmp)
		// }
	})
	return res
}

const state = {
	routes: [],
	addRoutes: []
}

const mutations = {
	SET_ROUTES: (state, routes) => {
		state.addRoutes = routes
		state.routes = routes
		state.routes = constantRoutes.concat(routes) // 路由白名单
	}
}

// 路由菜单生成
const actions = {
	generateRoutes({ commit }, roles) {
		return new Promise((resolve) => {
			if (roles && roles.length > 0) {
				let accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
				commit('SET_ROUTES', accessedRoutes)
				resolve(asyncRoutes)
			}
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
